var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6733 12.2758C13.565 12.265 13.435 12.265 13.3158 12.2758C10.7375 12.1891 8.69 10.0766 8.69 7.47663C8.69 4.82246 10.835 2.66663 13.5 2.66663C16.1542 2.66663 18.31 4.82246 18.31 7.47663C18.2992 10.0766 16.2517 12.1891 13.6733 12.2758Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25667 16.2734C5.635 18.0284 5.635 20.8884 8.25667 22.6325C11.2358 24.6259 16.1217 24.6259 19.1008 22.6325C21.7225 20.8775 21.7225 18.0175 19.1008 16.2734C16.1325 14.2909 11.2467 14.2909 8.25667 16.2734Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.8d979851ad3b5c76ed473b3c4fafa5f2.svg";
export { ForwardRef as ReactComponent };